import { render, staticRenderFns } from "./FaqThemeProfile.vue?vue&type=template&id=613d5e80"
import script from "./FaqThemeProfile.vue?vue&type=script&lang=js"
export * from "./FaqThemeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports